import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ccb28dbc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "inconsistent-campaign-states-tooltip"
};
const _hoisted_2 = {
  class: "inconsistent-state-title"
};
const _hoisted_3 = {
  class: "inconsistent-state-body"
};
const _hoisted_4 = {
  class: "inconsistent-state-bottom"
};
const _hoisted_5 = {
  class: "inconsistent-state-bottom-text"
};
const _hoisted_6 = {
  class: "inconsistent-state-bottom-buttons"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_alert_octagon = _resolveComponent("alert-octagon");
  const _component_pause_icon = _resolveComponent("pause-icon");
  const _component_play_icon = _resolveComponent("play-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_alert_octagon), _createTextVNode(" Warning! ")]), _createElementVNode("div", _hoisted_3, " Some " + _toDisplayString($props.type) + " in this group have different and inconsistent statuses. ", 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createTextVNode(" Fix this issue by applying a "), _createElementVNode("u", null, "consistent status to all " + _toDisplayString($props.type), 1), _createTextVNode(" inside this group ")]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "apply-state-button",
    onClick: _cache[0] || (_cache[0] = () => {
      _ctx.$emit('pause-all');
    })
  }, [_createVNode(_component_pause_icon, {
    height: 16,
    width: 16
  }), _createTextVNode(" Pause all")]), _createElementVNode("div", {
    class: "apply-state-button activate",
    onClick: _cache[1] || (_cache[1] = () => {
      _ctx.$emit('enable-all');
    })
  }, [_createVNode(_component_play_icon, {
    height: 16,
    width: 16
  }), _createTextVNode(" Activate all")])])])]);
}